import { PaymentMethod } from "@/services/core-api-adapter";
import { PaymentType } from "@unu/ui-enums";

type PaymentTypeValue = (typeof PaymentType)[keyof typeof PaymentType];

/**
 * Maps core API PaymentMethod to AppsFlyer PaymentType for event tracking.
 */
export function mapPaymentMethodToPaymentType(
  method: PaymentMethod
): PaymentTypeValue {
  switch (method) {
    case PaymentMethod.EcentricEFT:
      return PaymentType.Eft;
    case PaymentMethod.CardNotPresent:
      return PaymentType.Card;
    case PaymentMethod.OneVoucher:
    case PaymentMethod.CareCardVoucher:
      return PaymentType.OneVoucher;
  }
}
